import './Posts.scss';

class Posts {

	constructor(node) {
		this.node = node;
	}

	init() {
	}

}

JSModules['Posts'] = Posts;
export default Posts;
